import { isRouteErrorResponse, Link, useRouteError } from 'react-router';
import { RotateCw, TriangleAlert } from 'lucide-react';
import { ErrorAlert } from '../components/ErrorAlert';
import { RobotMark } from '../components/Logo';
import NotFoundPage from './NotFoundPage';

/** Rendered when a page throws while rendering (a bug), or for unmatched routes. */
export default function RouteErrorPage() {
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundPage />;
  return (
    <div className="mx-auto flex max-w-2xl animate-rise flex-col items-center gap-5 px-4 py-12 text-center">
      <div className="relative">
        <RobotMark className="size-20" />
        <span className="dr-tint-error absolute -right-3 -bottom-2 grid size-9 place-items-center rounded-full ring-4 ring-canvas">
          <TriangleAlert className="size-4.5" aria-hidden="true" />
        </span>
      </div>
      <div className="space-y-2">
        <h1 className="text-2xl font-bold tracking-tight sm:text-3xl">This page failed to load</h1>
        <p className="text-base-content/65">Nothing was changed by this error. Reload the page; if it keeps happening, report it with the time it occurred.</p>
      </div>
      <div className="w-full text-left">
        <ErrorAlert error={isRouteErrorResponse(error) ? new Error(`${error.status} ${error.statusText}`) : error} title="Unexpected error in the administrator" />
      </div>
      <div className="flex flex-wrap justify-center gap-2">
        <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
          <RotateCw className="size-4" aria-hidden="true" />
          Reload
        </button>
        <Link to="/" className="btn btn-ghost">
          Overview
        </Link>
      </div>
    </div>
  );
}
